import React from "react";
import { ButtonVariantComponentHolderMainDiv } from "../../../../../styles/reusable/buttonstyles/buttonstyles";

interface ButtonComponentInterface {
  link?: string;
  onclick?: () => void;
  title: string;
}
const ButtonComponentVariant = ({
  link,
  onclick,
  title,
}: ButtonComponentInterface) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onclick) {
      e.preventDefault();
      onclick();
    }
  };

  return (
    <ButtonVariantComponentHolderMainDiv>
      <a href={link??"/"} onClick={handleClick}>
        <div className="circle" />
        <div className="top-blur" />
        <div className="radial-gradient" />
        <div className="inset" />
        <div className="button-holder">
          <div className="button-label">
            <p className="button-label-text">{title}</p>
          </div>
          <div className="button-label-2">
            <p className="button-label-text">{title} </p>
          </div>
        </div>
      </a>
    </ButtonVariantComponentHolderMainDiv>
  );
};

export default ButtonComponentVariant;

